"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseIconScoring = exports.baseIcon = exports.UncheckedStatus = exports.StyledIconsWrapper = exports.StepOverviewCardStatic = exports.StepOverviewCardLink = exports.StepNumberMobile = exports.StepNumberDesktop = exports.StepContentWrapper = exports.StepContentMobile = exports.StepContentDesktop = exports.StatusIcons = exports.SkippedStatus = exports.ReportIssueIconScoring = exports.ReportIssueIcon = exports.IconWrapper = exports.Content = exports.CheckedStatus = exports.AddDetailsIconScoring = exports.AddDetailsIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../styles/vars");
var _palette = require("../../styles/palette");
var _Link = _interopRequireDefault(require("../Link"));
var _StepContent = require("../StepContent");
var _StepNumber = require("../StepNumber");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var StepOverviewCardStatic = exports.StepOverviewCardStatic = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepOverviewCardStatic",
  componentId: "sc-pcac16-0"
})(["position:relative;display:block;height:100%;width:100%;"]);
var StepOverviewCardLink = exports.StepOverviewCardLink = StepOverviewCardStatic.withComponent(_Link["default"]);
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-pcac16-1"
})(["", ";background:#fff;border-radius:", "px;height:100%;overflow:hidden;display:flex;flex-direction:column;"], function (p) {
  return (0, _vars.cardShadowCss)(p.device === 'desktop' && p.isLink);
}, function (p) {
  return _vars.borderRadius[p.device];
});
var StepContentDesktop = exports.StepContentDesktop = (0, _styledComponents["default"])(_StepContent.StepContentDesktop).withConfig({
  displayName: "styles__StepContentDesktop",
  componentId: "sc-pcac16-2"
})(["margin:0.5rem 1rem 0.75rem 1rem;max-height:4.5rem;"]);
var StepContentMobile = exports.StepContentMobile = (0, _styledComponents["default"])(_StepContent.StepContentMobile).withConfig({
  displayName: "styles__StepContentMobile",
  componentId: "sc-pcac16-3"
})(["margin:0.5rem 0.75rem 0.5rem 0.75rem;max-height:3.5rem;"]);
var StepNumberDesktop = exports.StepNumberDesktop = (0, _styledComponents["default"])(_StepNumber.StepNumberDesktop).withConfig({
  displayName: "styles__StepNumberDesktop",
  componentId: "sc-pcac16-4"
})(["left:0;position:absolute;top:1rem;left:0;transform:translateX(-50%);z-index:100;"]);
var StepNumberMobile = exports.StepNumberMobile = StepNumberDesktop.withComponent(_StepNumber.StepNumberMobile);
var StatusIcons = exports.StatusIcons = _styledComponents["default"].div.withConfig({
  displayName: "styles__StatusIcons",
  componentId: "sc-pcac16-5"
})(["display:flex;padding:0px 12px 10px;"]);
var baseIcon = exports.baseIcon = "\n  width: 15px;\n  height: 15px;\n  margin-right: 8px;\n  border-radius: 3px;\n  margin-top: 8px;\n";
var CheckedStatus = exports.CheckedStatus = _styledComponents["default"].div.withConfig({
  displayName: "styles__CheckedStatus",
  componentId: "sc-pcac16-6"
})(["", " background:", ";"], baseIcon, _palette.checklistColors.green);
var UncheckedStatus = exports.UncheckedStatus = _styledComponents["default"].div.withConfig({
  displayName: "styles__UncheckedStatus",
  componentId: "sc-pcac16-7"
})(["", " background:", ";"], baseIcon, _palette.checklistColors.red);
var SkippedStatus = exports.SkippedStatus = _styledComponents["default"].div.withConfig({
  displayName: "styles__SkippedStatus",
  componentId: "sc-pcac16-8"
})(["", " border:1px solid ", ";"], baseIcon, _palette.commonPalette.borderGrey);
var AddDetailsIcon = exports.AddDetailsIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'add-details'
}).withConfig({
  displayName: "styles__AddDetailsIcon",
  componentId: "sc-pcac16-9"
})(["", " color:#0172CB;"], baseIcon);
var ReportIssueIcon = exports.ReportIssueIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'report-issue'
}).withConfig({
  displayName: "styles__ReportIssueIcon",
  componentId: "sc-pcac16-10"
})(["", " color:#F31414;"], baseIcon);
var StepContentWrapper = exports.StepContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepContentWrapper",
  componentId: "sc-pcac16-11"
})(["flex:1;display:flex;flex-direction:column;justify-content:space-between;"]);
var baseIconScoring = exports.baseIconScoring = "\npadding: 4px;\nwidth: 23px;\nheight: 23px;\nmargin-right: 4px;\nborder-radius: 3px;\nmargin-top: 8px;\ncolor: white;\nbackground-color: #000000;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nflex-shrink: 0;\n@media (max-width: 800px) {\n  width: 20px;\n  height: 20px;\n  margin-right: 1px;\n}\n";
var AddDetailsIconScoring = exports.AddDetailsIconScoring = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'add-details'
}).withConfig({
  displayName: "styles__AddDetailsIconScoring",
  componentId: "sc-pcac16-12"
})(["", ""], baseIconScoring);
var ReportIssueIconScoring = exports.ReportIssueIconScoring = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'report-issue'
}).withConfig({
  displayName: "styles__ReportIssueIconScoring",
  componentId: "sc-pcac16-13"
})(["", ""], baseIconScoring);
var IconWrapper = exports.IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-pcac16-14"
})(["display:inline-flex;padding:4px;"]);
var StyledIconsWrapper = exports.StyledIconsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledIconsWrapper",
  componentId: "sc-pcac16-15"
})(["right:0;position:absolute;z-index:1000;"]);
//# sourceMappingURL=styles.js.map